module.exports = require("./../../_gen/openfl/utils/ByteArrayData");